<div id="delete-vcc-dialog-confirmpopup" class="confirmpopup">
    <div id="delete-vcc-dialog-dialog-title" mat-dialog-title>
      <label id="delete-vcc-dialog-title-label" class="title">Delete VCC: Confirmation</label>
    </div>
    <hr id="delete-vcc-dialog-first-hr">
    <div id="delete-vcc-dialog-dialog-content" mat-dialog-content>
      <p id="delete-vcc-dialog-content-p">Are you sure you want to delete virtual credit card for '{{data.adxBookingId}}' service?</p>
    </div>
    <hr id="delete-vcc-dialog-second-hr">
    <div id="delete-vcc-dialog-dialog-actions" mat-dialog-actions style="float: right;">
      <button
        id="delete-vcc-dialog-ok-button"
        type="submit" mat-raised-button
        (click)="okClick()"
        color="primary"
        cdkFocusInitial matTooltip="Delete Virtual Credit Card"
        aria-label="Delete Virtual Credit Card">
      <mat-spinner
        id="delete-vcc-dialog-spinner"
        color="accent"
        *ngIf="isLoadingSpinner"
        diameter="30">
      </mat-spinner>
        <span id="delete-vcc-dialog-ok-span" *ngIf="!isLoadingSpinner">Ok</span>
      </button>
      <button
        id="delete-vcc-dialog-no-button"
        mat-raised-button
        (click)="onNoClick()"
        color="warn">
        No Thanks
      </button>
    </div>
  </div>
